import { restoreScript } from '@core/utils/dom';
import { Utilities } from './Utilities';
export class ComponentFactory {
    constructor(contexts) {
        this.objects = [];
        Utilities.forEach(contexts, context => {
            var _a;
            if (typeof ((_a = window.WidgetView) === null || _a === void 0 ? void 0 : _a[context.type]) !== 'undefined') {
                this.objects.push(new window.WidgetView[context.type](restoreScript(context)));
            }
        });
    }
}
